import { DefaultValueConfig } from '@headless-workspace/config';
import { CountrySelectorValue, unwrapResultSuccess } from '@headless-workspace/core-domain';
import { PropsWithLocale } from '@headless-workspace/glow-ds';
import {
    AsyncComponent,
    CategoryValue,
    EcomConfigKeys,
    FreeShippingPriceValue,
    getCachedEcomConfigByKey,
    Header,
    isMySephoraLoyaltyProgramActivated,
    LoyaltyConfigsValue,
    PersistentBanner,
    PersistentBannerSlotValue,
    VipBrandsValue,
} from '../../../../../src';
import { CommonDI, StorageRepositoryType } from '../../../../DI';

type HeaderContainerProps = PropsWithLocale & {
    categories: CategoryValue[];
    isH1Logo: boolean;
    persistentBannerData?: PersistentBannerSlotValue;
    vipBrands: VipBrandsValue;
    countrySelector?: CountrySelectorValue;
    hostUrl: string | null;
    isMobileSearchEnabled?: boolean;
};

const SUFFIX_HEADER_SLOT_MYSEPHORA = '_MySephora';

export const HeaderContainer: AsyncComponent<HeaderContainerProps> = async ({
    locale,
    vipBrands,
    categories,
    isH1Logo,
    persistentBannerData,
    countrySelector,
    hostUrl,
    isMobileSearchEnabled,
}) => {
    const headerSlotSuffix = (await isMySephoraLoyaltyProgramActivated(locale))
        ? locale + SUFFIX_HEADER_SLOT_MYSEPHORA
        : locale;

    const [freeShippingPriceResult, enablePriceLegalMentionsResult, headerSlotsResult, loyaltyConfigsResult] =
        await Promise.all([
            getCachedEcomConfigByKey(locale, EcomConfigKeys.ProductPriceShippingThreshold),
            getCachedEcomConfigByKey(locale, EcomConfigKeys.EnablePriceLegalMentions),
            CommonDI.get(StorageRepositoryType).getHeaderSlots(headerSlotSuffix),
            getCachedEcomConfigByKey(locale, EcomConfigKeys.LoyaltyConfig),
        ]);

    const headerSlots = unwrapResultSuccess(headerSlotsResult);
    const maxFreeShippingPrice =
        unwrapResultSuccess(freeShippingPriceResult)?.maxFreeShippingPrice ?? DefaultValueConfig.maxFreeShippingPrice;
    const enablePriceExceptionLegalMentions = unwrapResultSuccess(enablePriceLegalMentionsResult) ?? false;
    const isEnableOffers = unwrapResultSuccess(loyaltyConfigsResult)?.isEnableOffers ?? false;

    return (
        <Header
            topBannerChildren={persistentBannerData && <PersistentBanner locale={locale} data={persistentBannerData} />}
            totalForFreeShipping={maxFreeShippingPrice}
            locale={locale}
            enablePriceExceptionLegalMentions={enablePriceExceptionLegalMentions}
            isH1Logo={isH1Logo}
            categories={categories}
            vipBrands={vipBrands}
            headerSlots={headerSlots}
            isEnableOffers={isEnableOffers}
            countrySelector={countrySelector}
            hostUrl={hostUrl}
            isMobileSearchEnabled={isMobileSearchEnabled}
        />
    );
};
